// extracted by mini-css-extract-plugin
module.exports = {"donation":"kr","donationIcon":"ks","donationTitle":"kt"};